import React from 'react';
import { EChartsWrapper } from './echarts-wrapper';
import { createColumnChartOption } from '../lib/chart-options';
import type { ChartData } from '@/entities/dashboard';

interface ColumnChartProps {
  data: ChartData;
  height?: number | string;
  className?: string;
  loading?: boolean;
}

export const ColumnChart: React.FC<ColumnChartProps> = ({ data, height, className, loading }) => {
  const option = createColumnChartOption(data);

  return <EChartsWrapper option={option} height={height} className={className} loading={loading} />;
};
